export const VERSION_NUMBER = '1.000';
export const BUILD_TIME = '2019-12-05T15:55:15.455Z';
export const BUILD_NOTES = `
<ul>
    <li>Initial launch of site.</li>
</ul>`;

